import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import TopNav from "../../Components/Dashboards/TopNav";
import Notifications from "../../Components/Dashboards/Notifications";
import NavHeader2 from "../../Components/Dashboards/NavHeader2";
import Sidebar from "../../Components/Dashboards/Sidebar";
import Footer from "../../Components/Dashboards/Footer";
import BreadcrumTop from "../../Components/Dashboards/BreadcrumTop";
import Swal from "sweetalert2";
import { useUpdateProduct } from "../../Components/Dashboards/../../hooks/useProducts";

export default function UpdateProduct(props) {
  const { isLoaded } = props;

  const [id, setId] = useState("");
  const [marketerId, setMarketerId] = useState("");
  const [name, setName] = useState("");

  const navigate = useNavigate();
  const location = useLocation();
  const rowData = location.state?.rowData;

  const updateProductMutation = useUpdateProduct();

  useEffect(() => {
    document.title = "Update Product | Dashboard";
  }, []);

  useEffect(() => {
    if (rowData) {
      setId(rowData.id || "");
      setMarketerId(rowData.marketerId || "");
      setName(rowData.name || "");
    }
  }, [rowData]);

  // Validation function
  const validateForm = () => {
    if (!marketerId) return showError("Marketer ID is required.");
    if (!name) return showError("Product Name is required.");

    return true;
  };

  const showError = (message) => {
    Swal.fire({ title: "Error", text: message, icon: "error" });
    return false;
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    const formData = {
      marketerId: parseInt(marketerId),
      name,
    };

    updateProductMutation.mutate({
      id,
      productData: formData,
    });
  };

  return (
    <>
      <div id="main-wrapper" className={isLoaded ? "show" : ""}>
        <TopNav />
        <Notifications />
        <NavHeader2 />
        <Sidebar />

        <div className="content-body">
          <div className="container-fluid">
            <BreadcrumTop title="Update Product" />

            <div className="row">
              <div className="d-flex justify-content-center align-items-center">
                <div className="col-xl-7 col-lg-10 col-md-10">
                  <div className="card">
                    <div className="card-body">
                      <form onSubmit={handleSubmit}>
                        <input type="hidden" name="id" value={id} />

                        <div className="mb-3 row">
                          <div className="col-sm-10">
                            <input
                              type="hidden"
                              name="marketerId"
                              value={marketerId}
                              onChange={(e) => setMarketerId(e.target.value)}
                              className="form-control"
                              placeholder="Enter Marketer ID"
                            />
                          </div>
                        </div>

                        <div className="mb-3 row">
                          <label className="col-sm-2 col-form-label">
                            Product Name
                          </label>
                          <div className="col-sm-10">
                            <input
                              type="text"
                              name="name"
                              value={name}
                              onChange={(e) => setName(e.target.value)}
                              className="form-control"
                              placeholder="Enter Product Name"
                            />
                          </div>
                        </div>

                        <div className="mb-3 mt-4 row">
                          <div className="col-sm-12 d-flex justify-content-end">
                            <button
                              type="submit"
                              className="btn btn-primary m-1"
                              disabled={updateProductMutation.isLoading}
                            >
                              {updateProductMutation.isLoading ? (
                                <span
                                  className="spinner-border spinner-border-sm"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                              ) : (
                                "Update Product"
                              )}
                            </button>
                            <Link to="/products" className="btn btn-dark m-1">
                              Go Back
                            </Link>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
}